// Angular
import '@angular/common';
import '@angular/compiler';
import '@angular/core';
import '@angular/http';
import '@angular/forms';
import '@angular/router';
import '@angular/platform-browser';
import '@angular/platform-browser-dynamic';
import '@angular/upgrade';
import '@angular/animations';
import '@angular/cdk';
import '@angular/material';
import '@angular/flex-layout';

import 'rxjs';
import 'class-transformer';
import 'ngx-color-picker';
import 'hammerjs';
import 'jquery';
import 'popper.js';
import 'angular5-csv/Angular5-csv';
import 'tslib';

import '@progress/kendo-angular-buttons';
import '@progress/kendo-angular-charts';
import '@progress/kendo-angular-common';
import '@progress/kendo-angular-dateinputs';
import '@progress/kendo-angular-dialog';
import '@progress/kendo-angular-dropdowns';
import '@progress/kendo-angular-excel-export';
import '@progress/kendo-angular-gauges';
import '@progress/kendo-angular-grid';
import '@progress/kendo-angular-inputs';
import '@progress/kendo-angular-intl';
import '@progress/kendo-angular-l10n';
import '@progress/kendo-angular-label';
import '@progress/kendo-angular-layout';
import '@progress/kendo-angular-pdf-export';
import '@progress/kendo-angular-popup';
import '@progress/kendo-angular-tooltip';
import '@progress/kendo-angular-treeview';
import '@progress/kendo-data-query';
import '@progress/kendo-drawing';
import '@progress/kendo-theme-default';
import '@progress/telerik-angular-report-viewer';
import '@devexpress/analytics-core';
import 'devexpress-reporting-angular';
import 'devextreme/bundles/dx.all';


// WEBPACK FOOTER //
// ./node_modules/angular2-template-loader!./Scripts/vendor.ts